// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fingerprint-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.50348 21C3.53767 18.8653 3 16.4954 3 14V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V13M9.64233 21C8.28993 19.0028 7.5 16.5937 7.5 14V11C7.5 8.51472 9.51472 6.5 12 6.5C14.4853 6.5 16.5 8.51472 16.5 11V14C16.5 15.933 18.067 17.5 20 17.5H21M12 11V14C12 17.012 13.6646 19.6353 16.124 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fingerprint2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fingerprint-2',
    ref,
    icon: element,
  },
));

Fingerprint2Icon.displayName = 'Fingerprint2Icon';

export default Fingerprint2Icon;
